import { DataConnect } from "./types";

export const initialDataConnectState: DataConnect = {
  appConnectData: {},
  isDbConnecting: false,
  connectingColumns: [],
  yoomDatabaseEditData: null,
  relationUpdateCurrentId: null,
};
